import React, { useState } from "react";
import axios from "axios";
import { InputField } from "./InputField";

export const VoucherInput = ({
  onApplyVoucher,
  disabled,
  eventId,
  category,
}) => {
  const [voucherCode, setVoucherCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleApply = async () => {
    setMessage("");
    if (!voucherCode) {
      setMessage("Please enter voucher code.");
      return;
    }

    setLoading(true);
    const payload = { code: voucherCode.trim(), eventId, kategori: category };
    console.log("Sending voucher validation payload:", payload);
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_BASE_URL}/api/validate-voucher`,
        payload
      );
      const { discountPercentage } = response.data;
      onApplyVoucher(voucherCode, discountPercentage);
      setMessage(
        discountPercentage === 100
          ? "Voucher Code Valid! You are eligible to register."
          : `Voucher applied successfully! Discount ${discountPercentage}%`
      );
    } catch (err) {
      setMessage(err.response?.data?.message || "Invalid voucher.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col my-4">
      {/* Label */}
      <label className="text-slate-800 font-medium mb-1">Voucher Code</label>

      {/* Input + Button sejajar */}
      <div className="flex gap-4">
        <div className="flex-1">
          <InputField
            type="text"
            value={voucherCode}
            onChange={(e) => setVoucherCode(e.target.value.toUpperCase())}
            placeholder="Enter voucher code"
            disabled={disabled || loading}
          />
        </div>
        <button
          type="button"
          onClick={handleApply}
          disabled={disabled || loading}
          className={`px-4 bg-red-900 text-white rounded-xl hover:bg-red-700 transition duration-300 w-[120px] flex items-center justify-center ${
            disabled || loading ? "opacity-50 cursor-not-allowed" : ""
          }`}
          style={{ height: "44px" }} // samakan tinggi dengan InputField
        >
          {loading ? "Loading..." : "Apply"}
        </button>
      </div>

      {/* Pesan */}
      {message && (
        <p
          className={`mt-4 text-sm ${
            message.includes("successfully") || message.includes("Valid")
              ? "text-green-600"
              : "text-rose-600"
          }`}
        >
          {message}
        </p>
      )}
    </div>
  );
};
